import * as React from 'react';
import { useCallbackRef } from './useCallbackRef';

/**
 * Слушает нажатие клавиши escape
 */
function useEscapeKeydown(onEscapeKeyDownProp) {
  let ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const onEscapeKeyDown = useCallbackRef(onEscapeKeyDownProp);
  React.useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onEscapeKeyDown(event);
      }
    };
    ownerDocument.addEventListener('keydown', handleKeyDown, {
      capture: true
    });
    return () => ownerDocument.removeEventListener('keydown', handleKeyDown, {
      capture: true
    });
  }, [onEscapeKeyDown, ownerDocument]);
}
export { useEscapeKeydown };